// split is used for getting namespace of channel
// f.e. namespace of 'casino-big-wins-feed:domain-COM-live-casino-desktop'
// is 'casino-big-wins-feed'
export const getChannelNamespace = (channel) => {
  if (!channel || typeof channel !== 'string') {
    return '';
  }
  const [namespace] = channel.split(/:|-(?=[A-Z]{3}$)/g);
  return namespace;
};
